import styled from 'styled-components';
import {
  Table as SemanticTable,
} from 'semantic-ui-react';

export const Cell = styled(SemanticTable.Cell)`
  &.ui.celled.table tr td:first-child {
    z-index: 4;
    position: sticky;
    left: 0;
    background-color: white;
  }

  &.ui.table thead tr:first-child>th:first-child {
    z-index: 6;
    top: 0;
    left: 0;
  }
`;
